import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import LogoLoader from "./Common/LogoLoader";

const API = process.env.REACT_APP_AUTH_API
  ? process.env.REACT_APP_AUTH_API.replace("/api/auth", "/api")
  : "/api";

const ALLOWED_REDIRECT_PREFIXES = ["/app/", "/live-chat", "/auth/"];

export default function AutoLogin() {
  const { login } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const rawRedirect = params.get("redirect") || "";
    const redirect = ALLOWED_REDIRECT_PREFIXES.some(p => rawRedirect.startsWith(p))
      ? rawRedirect
      : "/app/dashboard";

    const doLogin = async () => {
      if (token) {
        try {
          // Send token to backend — it validates and sets httpOnly cookie
          const res = await fetch(`${API}/auth/set-cookie`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token }),
            credentials: "include",
          });
          if (res.ok) {
            const data = await res.json();
            if (data.user) login({ user: data.user });
          }
        } catch {}
      }
      window.location.replace(redirect);
    };

    doLogin();
  }, [login]);

  return <LogoLoader message="Signing you in…" />;
}
